// import type { Pagination } from 'types/api';
const VITE_FACADE_API_GATEWAY = import.meta.env.VITE_FACADE_API_GATEWAY;
const VITE_TC_API_GATEWAY = import.meta.env.VITE_TC_API_GATEWAY;
const VITE_CONTRACTOR_API_GATEWAY = import.meta.env.VITE_CONTRACTOR_API_GATEWAY;
const VITE_LOCATION_ENDPOINT = import.meta.env.VITE_LOCATION_ENDPOINT;
const VITE_WORKER_ENDPOINT = import.meta.env.VITE_WORKER_API_GATEWAY;
const VITE_SCHEDULE_ENDPOINT = import.meta.env.VITE_SCHEDULE_API_GATEWAY;
const VITE_MESSAGES_API_GATEWAY = import.meta.env.VITE_MESSAGES_API_GATEWAY;

export default {
  locations: {
    getAll: (params: string = '') => {
      return `${VITE_LOCATION_ENDPOINT}locations?${params}`;
    },
    getSingle: (id: string, params: string = '') => `${VITE_LOCATION_ENDPOINT}locations/${id}?${params}`,
  },

  facade: {
    getPagePermissions: (groupId: string) => `${VITE_FACADE_API_GATEWAY}permissions/${groupId}`,
    createPresignedUrl: () => `${VITE_FACADE_API_GATEWAY}presigned`,
  },

  tc: {
    addUser: () => `${VITE_FACADE_API_GATEWAY}tc/users`,
    getSingleFromUEN: (uen: string) => `${VITE_TC_API_GATEWAY}tc?uen_tc=${uen}`,
    getSingleFromUID: (id: string) => `${VITE_TC_API_GATEWAY}tc/${id}`,
    editUser: (id: string) => `${VITE_FACADE_API_GATEWAY}tc/users/${id}`,
    deleteUser: (id: string) => `${VITE_FACADE_API_GATEWAY}tc/users/${id}`,
    getUserRegistration: (id: string) => `${VITE_TC_API_GATEWAY}tc/users/${id}/registration`,
    updateUserRegistration: (id: string) => `${VITE_TC_API_GATEWAY}tc/users/${id}/registration`,
    getProfile: (profileId: string) => `${VITE_TC_API_GATEWAY}tc/users/${profileId}`,
    getAll: (params: string = '') => `${VITE_TC_API_GATEWAY}tc?${params}`,
    getSingle: (id: string, params: string = '') => `${VITE_TC_API_GATEWAY}tc/${id}?${params}`,
    addTC: () => `${VITE_TC_API_GATEWAY}tc`,
    editTC: (id: string) => `${VITE_TC_API_GATEWAY}tc/${id}`,
    deleteTC: (id: string) => `${VITE_TC_API_GATEWAY}tc/${id}`,
    getAllUsers: (params: string = '') => `${VITE_TC_API_GATEWAY}tc/users?${params}`,
    getSingleUser: (id: string, params: string = '') => `${VITE_TC_API_GATEWAY}tc/users/${id}?${params}`,
    getWorkers: (params: string = '') => `${VITE_WORKER_ENDPOINT}workers?${params}`,
    getUserName: (id: string) => `${VITE_FACADE_API_GATEWAY}tc/usernames/${id}`,
  },

  contractors: {
    addUser: () => `${VITE_FACADE_API_GATEWAY}contractors/users`,
    editUser: (id: string) => `${VITE_FACADE_API_GATEWAY}contractors/users/${id}`,
    deleteUser: (id: string) => `${VITE_FACADE_API_GATEWAY}contractors/users/${id}`,
    getUserRegistration: (id: string) => `${VITE_CONTRACTOR_API_GATEWAY}contractors/users/${id}/registration`,
    updateUserRegistration: (id: string) => `${VITE_CONTRACTOR_API_GATEWAY}contractors/users/${id}/registration`,
    getUserProfile: (profileId: string) => `${VITE_CONTRACTOR_API_GATEWAY}contractors/users/${profileId}`,
    getAll: (params: string = '') => `${VITE_CONTRACTOR_API_GATEWAY}contractors?${params}`,
    getSingle: (id: string) => `${VITE_FACADE_API_GATEWAY}contractors/${id}`,
    addContractorWithUser: () => `${VITE_FACADE_API_GATEWAY}contractors`,
    editContractor: (id: string) => `${VITE_FACADE_API_GATEWAY}contractors/${id}`,
    deleteContractor: (id: string) => `${VITE_FACADE_API_GATEWAY}contractors/${id}`,
    getAllUsers: (params: string = '') => `${VITE_CONTRACTOR_API_GATEWAY}contractors/users?${params}`,
    getSingleUser: (id: string, params: string = '') =>
      `${VITE_CONTRACTOR_API_GATEWAY}contractors/users/${id}?${params}`,
    getUserName: (id: string) => `${VITE_FACADE_API_GATEWAY}contractors/usernames/${id}`,
  },

  workers: {
    // getWorkerProfile: (profileId: string) => `${workerEndpoint}workers/${profileId}`,
    getAll: (params: string = '') => `${VITE_WORKER_ENDPOINT}workers?${params}`,
    getSingle: (id: string, params: string = '') => `${VITE_WORKER_ENDPOINT}workers/${id}?${params}`,
    addNewWorker: () => `${VITE_WORKER_ENDPOINT}workers`,
    editWorker: (id: string) => `${VITE_WORKER_ENDPOINT}workers/${id}`,
    addPhototoAdhoc: (scheduleId: string, workerId: string) =>
      `${VITE_FACADE_API_GATEWAY}adhoc-schedules/${scheduleId}/workers/${workerId}`,
    deleteWorker: (id: string) => `${VITE_WORKER_ENDPOINT}workers/${id}`,
    updateWorkerApproval: (id: string, worker_type: string) =>
      `${VITE_WORKER_ENDPOINT}workers/${id}/approval?worker_type=${worker_type}`,
  },

  schedules: {
    getAdhoc: (id: string) => `${VITE_FACADE_API_GATEWAY}adhoc-schedules/${id}`,
    getAll: (params: string = '') => `${VITE_SCHEDULE_ENDPOINT}schedules?${params}`,
    getSingle: (id: string, params: string = '') => `${VITE_SCHEDULE_ENDPOINT}schedules/${id}?${params}`,
    addNew: (params: string = '') => `${VITE_FACADE_API_GATEWAY}schedules?${params}`,
    edit: (id: string = '') => `${VITE_FACADE_API_GATEWAY}schedules/${id}`,
    delete: (id: string = '') => `${VITE_SCHEDULE_ENDPOINT}schedules/${id}`,
    getWorkers: (id: string = '') => `${VITE_SCHEDULE_ENDPOINT}schedules/${id}/workers`,
    assignWorkers: (id: string = '', params: string = '') =>
      `${VITE_SCHEDULE_ENDPOINT}schedules/${id}/workers?${params}`,
    deleteWorkers: (id: string = '', worker_id: string = '') =>
      `${VITE_SCHEDULE_ENDPOINT}schedules/${id}/workers/${worker_id}`,
  },

  messages: {
    getAll: (params: string = '') => `${VITE_MESSAGES_API_GATEWAY}messages?${params}`,
    getAlarms: (params: string) => `${VITE_MESSAGES_API_GATEWAY}messages?message_type=alarm&${params}`,
    getEvents: (params: string) => `${VITE_MESSAGES_API_GATEWAY}messages?message_type=event&${params}`,
    clearAlarm: (id: string) => `${VITE_FACADE_API_GATEWAY}messages/${id}`,
    acknowledgeAlarm: (id: string) => `${VITE_FACADE_API_GATEWAY}messages/${id}?message_type=alarm`,
  },

  doors: {
    get: (id: string) => `${VITE_FACADE_API_GATEWAY}doors/${id}`,
    open: (id: string) => `${VITE_FACADE_API_GATEWAY}doors/${id}`,
  },
};
